import { DatePicker } from 'antd'
import React from 'react'
import CIMSSelect from 'components/CIMSSelect'
import { useSubmittalTrackerContext } from '../../../../../../SubmittalTrackerContext'
import CIMSFormItem from 'components/CIMSFormItem'

export const GroupReview: React.FC = () => {
  const {
    selectOptions: { routingGroupOptions },
  } = useSubmittalTrackerContext()
  return (
    <>
      <CIMSFormItem
        label="Contractual Review Date"
        name="contractualReviewDate"
        requiredMessage="Please enter a contractual review date"
      >
        <DatePicker />
      </CIMSFormItem>
      <CIMSFormItem
        label="Routing Groups"
        name="routingGroups"
        requiredMessage="Please select at least one routing group"
      >
        <CIMSSelect mode="multiple" options={routingGroupOptions} />
      </CIMSFormItem>
    </>
  )
}
